<template>
  <template v-if="formErrorMessage">
    <div
      class="mb-4 rounded-md bg-red-200 p-2 text-sm text-red-800"
    >
      <p class="">
        {{ formErrorMessage }}
      </p>
    </div>
  </template>
  <form class="space-y-6" novalidate @submit="onFormSubmit">
    <FormInputText
      id="email"
      name="email"
      type="email"
      autocomplete="email"
      required
      label="Email Address"
    />

    <div class="flex justify-end">
      <FormSubmitButton :is-loading="isSubmitting">
        Request Link
      </FormSubmitButton>
    </div>
  </form>
</template>

<script setup lang="ts">
import { toTypedSchema } from "@vee-validate/zod"
import { useForm } from "vee-validate"
import * as z from "zod"

const formErrorMessage = ref<string | null>(null)

const formSchema = z.object({
  email: z.string().email(),
})

const { handleSubmit, isSubmitting } = useForm({
  validationSchema: toTypedSchema(formSchema),
  initialValues: {
    email: "",
  },
})

const onFormSubmit = handleSubmit(async (values) => {
  formErrorMessage.value = null
  try {
    await requestLogInLink(values)
    toast.success(
      "If an active account was found, a login link has been sent to the requested email address",
      5000
    )
  } catch {
    formErrorMessage.value = "Failed to request login link"
  }
})
</script>
